import React, { useEffect, useRef, useState,useContext } from "react";
import { useNavigate } from 'react-router-dom';

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useOnboarding } from "../../context/OnboardingContext";
import JWTContext from '../../context/JWTContext';
import { SubmitHandler, useForm } from "react-hook-form";
import Swal from 'sweetalert2'


const schema = yup.object({
    ownerName: yup.string().required(),
    citizenID: yup.string().required(),
    bussinesstype:yup.string().required(),
    // agreement:yup.boolean().oneOf([true], "You must agree")
}).required();

const DocumentVerification = (  ) => {
    const navigate = useNavigate();

    const { saveStep,data } = useOnboarding();
   const { register: registerAccount } = useContext(JWTContext);

            const {
                register,
                handleSubmit,
                reset,
                
                setValue,
                formState: { errors }
            } = useForm({
                resolver: yupResolver(schema),
                defaultValues: {
                    bussinesstype: data.bussinesstype ?? "",
                    ownerName: data.ownerName ?? "",
                    citizenID: data.citizenID ?? "",
                    agreement: data.agreement ?? false,
                    email: data.email ?? "",
                    shopName: data.shopName ?? "",
                    phone: data.phone ?? "",
                    phoneCC: data.phone ?? "+62"
                }
            });

    const inputClass = (field) =>
        `form-control p-10 ${
            errors[field] ? "is-invalid" : ""
        }`;

    const inputradioClass = (field) =>
        `form-radio text-18 ${
            errors[field] ? "is-invalid" : ""
        }`;

    const inputcheckClass = (field) =>
        `form-check mb-0 custom-circular-checkbox ${
            errors[field] ? "is-invalid" : ""
        }`;

    const onSubmit = (data) => {
        if(data.agreement){
            saveStep({
                bussinesstype: data.bussinesstype,
                ownerName: data.ownerName,
                citizenID: data.citizenID,
                agreement:data.agreement
            });
            navigate("/registration-shop-information");
        }else {
                    Swal.fire({
                        title: "Error",
                        text: "Please accept the terms and conditions.",
                        icon: "error"
                    });
                }
        
    };

    const readUserData=()=> {
        if(localStorage.getItem('user')==null){
            navigate("/login")
        } 
    }
    
    useEffect(() => {
            readUserData();
        },[]);

  return (
    <div className="document-verification text_quicksand">
        <div className="container">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group mb-40">
                    <label className="fw-bold text-black mb-20">
                        Bussiness type <span className="text-danger">*</span>
                    </label>
                    <div className="mb-20">
                        <label className="d-flex align-items-center gap-10">
                            <input type="radio" {...register("bussinesstype")} value={"0"} className={inputradioClass("bussinesstype")}  /> 
                            <span className="text-14 text-black">Personal</span>
                        </label>
                    </div>
                    <div className="mb-20">
                        <label className="d-flex align-items-center gap-10">
                            <input type="radio" {...register("bussinesstype")} value={"1"} className={inputradioClass("bussinesstype")} /> 
                            <span className="text-14 text-black">Company</span>
                        </label>
                    </div>

                    {errors.bussinesstype && (
                                                    <small className="text-danger">
                                                    {errors.bussinesstype.message}
                                                    </small>
                                                )}
                </div>
                <div className="form-group mb-40">
                    <label className="form-label fw-bold mb-10">Owner Name <span className="text-danger">*</span></label>
                    <input type="text" className={inputClass("ownerName")} {...register("ownerName")} placeholder="Enter your name" />
                </div>
                <div className="form-group mb-40">
                    <label className="form-label fw-bold mb-10">Citizen ID <span className="text-danger">*</span></label>
                    <input type="text" className={inputClass("citizenID")} {...register("citizenID")} placeholder="Enter your name" />
                </div>

                <div className="form-group mb-20">
                    <label className="form-label d-flex align-items-center gap-10">
                        <div className="position-relative" >
                            <div className="position-absolute text-white" style={{left:"4px"}}><i class="ph-bold ph-check"></i></div>
                            <input type="checkbox" className={inputcheckClass("agreement")} {...register("agreement")}  />
                        </div>
                        <span className="fw-bold">I aggree with <span className="text-primary">Terms & Conditions</span>.</span>
                    </label>
                </div>

                <div className="p-20 text_quicksand mb-40" style={{backgroundColor:"#F1F1F1"}}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                </div>

                <div className="d-flex justify-content-end">
                    {/* <button className="btn btn_mart_primary" onClick={() => navigate("/registration-shop-information")} >Next</button> */}
                    <button className="btn btn_mart_primary" type="submit" >Next</button>
                </div>
            </form>
            
        </div>
    </div>
  );
};

export default DocumentVerification;